import * as Yup from 'yup';

export const NewAdressValidation = Yup.object({
  cep: Yup.string().min(9, 'Verifique se o CEP informado é válido').required('Informe o CEP com 8 dígitos'),
  logradouro: Yup.string().required('Logradouro deve ser preenchido'),
  numero: Yup.string().required('Informe o número'),
  bairro: Yup.string().required('Bairro deve ser preenchido'),
  cidade: Yup.string().required('Cidade deve ser preenchida'),
  estado: Yup.string().required('Estado deve ser preenchido')
});